export default "__VITE_ASSET__DQuIalLH__"